import { Roles } from 'modules/core/enums';
import { TableColumn } from 'modules/core/components/Table/types';
import { useCallback } from 'react';

import { SALESPERSON_ALLOWED_DEAL_STRUCTURE_FIELDS } from '../consts/consts';
import { COMMON_COLUMNS_NAMES } from '../common.const';

const isTechnical = (id: string) =>
  id === COMMON_COLUMNS_NAMES.startEmptyColumn || id === COMMON_COLUMNS_NAMES.endEmptyColumn;

export function useDealStructureFieldsByRole() {
  return useCallback(
    (columns: TableColumn[], role: Roles | undefined) =>
      columns.filter((column) => {
        if (isTechnical(column.id)) return true;

        if (role === Roles.SALESPERSON) {
          return SALESPERSON_ALLOWED_DEAL_STRUCTURE_FIELDS.has(column.id);
        }

        return true;
      }),
    [],
  );
}
